import { useEffect } from "react";
import { Form } from "antd";
import { useAtom } from "jotai";
import { frmPreguntasActitudTrabajoEquipoAtom, puntajeTotalActitudTrabajoEquipoAtom } from "../../BandejaEvaluacionStorage";

const usePreguntasActitudTrabajoEquipo = () => {
	const [puntajeTotal, setPuntajeTotal] = useAtom(puntajeTotalActitudTrabajoEquipoAtom);
	const [frmPreguntas, setFrmPreguntas] = useAtom(frmPreguntasActitudTrabajoEquipoAtom);
	const [form] = Form.useForm();

	useEffect(() => {
		if (!frmPreguntas) {
			setFrmPreguntas(form);
		}
	}, []);

	return { frmPreguntas, puntajeTotal, setPuntajeTotal };
};

export default usePreguntasActitudTrabajoEquipo;
